// extracted by mini-css-extract-plugin
module.exports = {"categories":"style_categories__3d1IF","count":"style_count__2BPEP"};